// extracted by mini-css-extract-plugin
export default {"revealItems":"price_revealItems__A-hR+","slideItems":"price_slideItems__BnTYU"};